{% verbatim %}
<div class="member-info button">
	<input type="hidden" class="member-info-value-{{section_id}}" value="{{text}}"/>
    <span>{{text}} <span class="icon-remove">X</span></span>
</div>
{% endverbatim %}
